/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable no-duplicate-imports */
/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Checkbox,
  Divider,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  InputBase,
  MenuItem,
  Select,
  styled,
  Switch,
  Typography
} from '@mui/material';
// import MatchesMainPage from './Matches/MatchesMainPage';
import ProgramUsers from './ProgramUsers';
import { useParams } from 'react-router-dom';
import { useAppSelector } from '../../../../../../redux/hooks';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import StarsIcon from '@mui/icons-material/Stars';
import { toast } from 'react-toastify';
import { API } from '../../../../../../api';
import useGroupDetails from '../../../../../../queries/useGroupDetails';
import { getUserDetails } from '../../../../../../utils/orgName';
import ContentSettings from './ContentSettings';
import MatchesMainPage from '../../../Matches/MatchesMainPage';
// import { API } from '../../../../../../../api';

// import { fetchAllTemplates } from '../../../../../../redux/slices/goals-templates/goalsTemplatesSlice';
import {
  ProgramCreationProvider,
  useProgramCreation
} from '../../../../../../components/admin3/newProgram/ProgramCreationContext';
import { ManualProgramBuilder } from '../../../../../../components/admin3/newProgram/masterclass/manual/ManualProgramBuilder';
import {
  LessonMaterial,
  FeedbackQuestion,
  MultipleChoiceQuestion,
  ModuleDraft,
  mapAnswerFormatToFeedbackType
} from '../../../../../../components/admin3/newProgram/masterclass/types';
import { nanoid } from 'nanoid';
interface RadioProps {
  checked: boolean;
  onChange: () => void;
}

interface Option {
  label: string;
  value: string;
}

interface RadioGroupProps {
  value: string;
  onChange: (value: string) => void;
  options: Option[];
}

interface ProgramModelSelectorProps {
  value: string;
  onChange: (value: string) => void;
}

const OPTIONAL_FIELD_KEYS = [
  'bio',
  'headshot',
  'dob',
  'country',
  'workHistory',
  'educationHistory',
  'hobbiesInterests',
  'socials',
  'companyName',
  'companyInfo',
  'companyPosition'
];

const mapTemplateToModules = (template: any): ModuleDraft[] => {
  const levels = template?.levels || [];
  return levels.map((level: any, levelIndex: number) => {
    const moduleId = level?._id || level?.levelId || nanoid();
    const tasks = [...(level?.tasks || [])].sort(
      (a, b) => (a?.taskPosition ?? a?.taskIndex ?? 0) - (b?.taskPosition ?? b?.taskIndex ?? 0)
    );

    const moduleLocalId = nanoid();
    return {
      id: moduleLocalId,
      sourceId: moduleId,
      title: level?.levelName || `Module ${levelIndex + 1}`,
      objective: level?.levelDescription || '',
      lessons: tasks.map((task: any, taskIndex: number) => {
        const lessonId = task?._id || task?.taskId || nanoid();
        const lessonLocalId = nanoid();
        const libraryArticles = Array.isArray(task?.libraryArticles) ? task.libraryArticles : [];
        const materials: LessonMaterial[] = libraryArticles
          .filter(Boolean)
          .map((articleId: string) => ({
            id: articleId || nanoid(),
            articleId,
            title: '',
            reference: '',
            source: 'library'
          }));

        const feedbackQuestions: FeedbackQuestion[] = (task?.menteeQuestions || []).map(
          (question: any, questionIndex: number) => ({
            id: question?._id || `${task?._id ?? task?.taskName ?? 'feedback'}-${questionIndex}`,
            _id: question?._id,
            prompt: question?.menteeQues || question?.menteeAsmtQues || `Question ${questionIndex + 1}`,
            type: mapAnswerFormatToFeedbackType(question?.menteeAnsType || question?.type)
          })
        );

        const multipleChoiceQuestions: MultipleChoiceQuestion[] = (task?.MCQ || []).map(
          (question: any, questionIndex: number) => {
            const rawOptions = question?.options || [];
            const mappedOptions = rawOptions.map((option: any, optionIndex: number) => {
              const label =
                typeof option === 'string'
                  ? option
                  : option?.optionText || option?.label || option?.value || `Option ${optionIndex + 1}`;
              const id =
                (typeof option === 'object' && (option?.id || option?._id || option?.value)) ||
                `${question?._id ?? task?._id ?? 'mcq'}-option-${optionIndex}`;
              return { id, label };
            });

            const normalizedOptions =
              mappedOptions.length > 0
                ? mappedOptions
                : [
                    { id: `${question?._id ?? task?._id ?? 'mcq'}-option-0`, label: 'Option 1' },
                    { id: `${question?._id ?? task?._id ?? 'mcq'}-option-1`, label: 'Option 2' }
                  ];

            const correctOptionId =
              normalizedOptions.find((opt: any) => opt.id === question?.correctAns)?.id || normalizedOptions[0]?.id || '';

            return {
              id: question?._id || `${task?._id ?? 'mcq'}-${questionIndex}`,
              _id: question?._id,
              prompt: question?.ques || `MCQ ${questionIndex + 1}`,
              options: normalizedOptions,
              correctOptionId
            };
          }
        );

        return {
          id: lessonLocalId,
          sourceId: lessonId,
          title: task?.taskName || `Lesson ${taskIndex + 1}`,
          description: task?.taskDescription || '',
          materials,
          feedbackQuestions: feedbackQuestions.length ? feedbackQuestions : [],
          multipleChoiceQuestions: multipleChoiceQuestions.length ? multipleChoiceQuestions : []
        };
      })
    };
  });
};

const UiCheckbox = styled(Checkbox)(() => ({
  width: 22,
  height: 22,
  padding: 3,
  cursor: 'pointer',

  '& .MuiSvgIcon-root': {
    display: 'none' // remove icon padrão
  },

  '& .MuiTouchRipple-root': {
    display: 'none' // remove ripple MUI
  },

  // Quadrado base (unchecked)
  '&:not(.Mui-checked) .checkbox-box': {
    width: 16.5,
    height: 16.5,
    background: 'rgba(0,0,0,0.90)',
    borderRadius: 2,
    outline: '2px solid #868686',
    outlineOffset: '-1px'
  },

  // Quadrado checked
  '&.Mui-checked .checkbox-box': {
    width: 16.5,
    height: 16.5,
    background: 'transparent',
    borderRadius: 2,
    outline: '2px solid #FDFDFD',
    outlineOffset: '-1px',
    position: 'relative'
  },

  // Checkmark (desenhado manualmente)
  '&.Mui-checked .checkbox-box::after': {
    content: '""',
    position: 'absolute',
    width: 8,
    height: 4,
    borderLeft: '2px solid #FDFDFD',
    borderBottom: '2px solid #FDFDFD',
    transform: 'rotate(-45deg)',
    top: 4,
    left: 4
  },

  // hover (leve)
  '&:hover .checkbox-box': {
    opacity: 0.85
  }
}));

const UiSwitch = styled(Switch)(() => ({
  padding: 0,
  width: 40,
  height: 20,

  '& .MuiSwitch-track': {
    background: '#1C1C1C !important',
    border: '1px solid #565656 !important',
    borderRadius: 999,
    boxSizing: 'border-box',
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    padding: '0 2px'
  },

  '& .MuiSwitch-switchBase': {
    padding: 1,
    transition: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(20px)',
      '& .MuiSwitch-thumb': {
        background: '#F79420'
      },
      '& + .MuiSwitch-track': {
        borderColor: '#565656'
      }
    },
    '&.Mui-disabled': {
      '& .MuiSwitch-thumb': { background: '#868686' },
      '& + .MuiSwitch-track': { borderColor: '#565656' }
    }
  },

  '& .MuiSwitch-thumb': {
    width: 14,
    height: 14,
    borderRadius: 999,
    background: '#565656',
    transition: '300ms'
  }
}));

const UiInput = styled(InputBase)(() => ({
  padding: '10px 12px',
  borderRadius: '6px',
  background: 'rgba(0, 0, 0, 0.70)',
  outline: '1px solid #868686',
  color: '#FDFDFD',
  fontSize: 14,
  fontWeight: 400,
  transition: 'outline-color .15s ease',
  fontFamily: 'Inter, sans-serif',
  '&:hover': { outlineColor: '#B4B4B4' },
  '&.Mui-focused': { outlineColor: '#F79420' }
}));

const UiSelect = styled(Select)(() => ({
  color: '#fff',
  background: 'rgba(0, 0, 0, 0.70)',
  outline: '1px solid #868686',
  borderRadius: 1,
  '& .MuiSelect-icon': { color: '#fff' }
}));

function CheckboxBox(props: any) {
  return (
    <UiCheckbox
      disableRipple
      icon={<div className="checkbox-box" />}
      checkedIcon={<div className="checkbox-box" />}
      {...props}
    />
  );
}

function Radio({ checked, onChange }: RadioProps) {
  return (
    <Box
      onClick={onChange}
      sx={{
        width: 20,
        height: 20,
        borderRadius: '50%',
        background: 'rgba(0,0,0,0.9)',
        border: checked ? '2px solid #FDFDFD' : '2px solid #868686',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        transition: '150ms border-color',
        '&:hover': {
          borderColor: '#FDFDFD66'
        }
      }}
    >
      {checked && (
        <Box
          sx={{
            width: 10,
            height: 10,
            borderRadius: '50%',
            background: '#FDFDFD'
          }}
        />
      )}
    </Box>
  );
}

interface GenericAccordionProps {
  title: string | React.ReactNode;
  children: React.ReactNode;
  defaultExpanded?: boolean;
  disabled?: boolean;
  rightContent?: React.ReactNode;
}

export function GenericAccordion({ title, children }: GenericAccordionProps) {
  return (
    <Accordion
      disableGutters
      sx={{
        background: 'transparent',
        borderBottom: '1px solid #2A2A2A',
        color: '#FDFDFD',
        '&:before': { display: 'none' }
      }}
    >
      <AccordionSummary
        expandIcon={
          <ExpandMoreIcon
            sx={{
              fontSize: 18,
              color: '#FDFDFD',
              transition: 'transform 0.2s'
            }}
          />
        }
        sx={{
          px: 0,
          py: 1.2,
          minHeight: 'unset',
          cursor: 'pointer',
          display: 'flex',
          flexDirection: 'row-reverse', // <- ÍCONE NA ESQUERDA
          '& .MuiAccordionSummary-content': {
            margin: 0,
            display: 'flex',
            alignItems: 'center'
          }
          // '& .MuiAccordionSummary-expandIconWrapper': {
          //   mr: 1, // espaço entre ícone e título
          // }
        }}
      >
        {typeof title === 'string' ? (
          <Typography fontSize={12} fontWeight={700} color="white">
            {title}
          </Typography>
        ) : (
          title
        )}
      </AccordionSummary>

      <AccordionDetails sx={{ p: 0, pt: 1 }}>{children}</AccordionDetails>
    </Accordion>
  );
}

const SettingsRow = ({ children }: { children: React.ReactNode }) => (
  <Box
    sx={{
      display: 'grid',
      gridTemplateColumns: `minmax(180px, 1fr) repeat(4, 80px)`,
      alignItems: 'center',
      gap: 8,
      py: 1.2
    }}
  >
    {children}
  </Box>
);

function BasicPanel({ fieldSettings, updateField, disabled }: any) {
  const fields = [
    { label: 'First Name', key: 'firstName' },
    { label: 'Last Name', key: 'lastName' },
    { label: 'Email', key: 'email' },
    { label: 'User Role', key: 'category' },
    { label: 'Time Zone', key: 'timezone' }
  ];

  return (
    <GenericAccordion title="Basic">
      {fields.map(({ label, key }) => (
        <FieldRow
          key={key}
          label={label}
          fieldKey={key}
          data={fieldSettings[key]}
          onChange={(role, val) => updateField(key, role, val)}
          disabled={disabled}
        />
      ))}
    </GenericAccordion>
  );
}

function DemographicPanel({ fieldSettings, updateField }: any) {
  const fields = [
    { label: 'Biography', key: 'bio' },
    { label: 'Profile Photo', key: 'headshot' },
    { label: 'DOB', key: 'dob' },
    { label: 'Country', key: 'country' }
  ];

  return (
    <GenericAccordion title="Demographic">
      {fields.map(({ label, key }) => (
        <FieldRow
          key={key}
          label={label}
          fieldKey={key}
          data={fieldSettings[key]}
          onChange={(role, val) => updateField(key, role, val)}
        />
      ))}
    </GenericAccordion>
  );
}

function PersonalPanel({ fieldSettings, updateField }: any) {
  const fields = [
    { label: 'Work History', key: 'workHistory' },
    { label: 'Education History', key: 'educationHistory' },
    { label: 'Hobbies & interests', key: 'hobbiesInterests' },
    { label: 'Socials', key: 'socials' }
  ];

  return (
    <GenericAccordion title="Personal, Career and Studies">
      {fields.map(({ label, key }) => (
        <FieldRow
          key={key}
          label={label}
          fieldKey={key}
          data={fieldSettings[key]}
          onChange={(role, val) => updateField(key, role, val)}
        />
      ))}
    </GenericAccordion>
  );
}

function CompanyPanel({ fieldSettings, updateField }: any) {
  const fields = [
    { label: 'Company Name', key: 'companyName' },
    { label: 'Company Information', key: 'companyInfo' },
    { label: 'Company Position', key: 'companyPosition' }
  ];

  return (
    <GenericAccordion title="Company">
      {fields.map(({ label, key }) => (
        <FieldRow
          key={key}
          label={label}
          fieldKey={key}
          data={fieldSettings[key]}
          onChange={(role, val) => updateField(key, role, val)}
        />
      ))}
    </GenericAccordion>
  );
}

function SubjectsPanel({
  subjects,
  openModal
}: {
  subjects: { name: string; type: 'topic' | 'industry' }[];
  openModal: () => void;
}) {
  return (
    <GenericAccordion
      title={
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography fontSize={12} fontWeight={700} color="white">
            Subjects
          </Typography>
          <>
            <Button
              disableRipple
              onClick={(e) => {
                e.stopPropagation();
                openModal();
              }}
              sx={{
                textTransform: 'none',
                borderRadius: '6px',
                display: 'inline-flex',
                alignItems: 'center',
                gap: 1,
                fontFamily: 'Inter, sans-serif',
                color: '#F79420',
                fontSize: 12,
                fontWeight: 600,
                px: 1,
                py: 0.5,
                '&:hover': {
                  background: 'rgba(247, 148, 32, 0.08)'
                }
              }}
            >
              Add New Subject
              <AddIcon sx={{ fontSize: 20, color: '#F79420' }} />
            </Button>
          </>
        </Box>
      }
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, pt: 1 }}>
        {subjects.length === 0 && (
          <Typography fontSize={12} color="#868686">
            No subjects added yet.
          </Typography>
        )}

        {subjects.map((s, i) => (
          <Box
            key={i}
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              p: 1,
              borderRadius: 1,
              background: 'rgba(0,0,0,0.7)',
              outline: '1px solid #2A2A2A'
            }}
          >
            <Typography sx={{ color: '#fff', fontSize: 13 }}>{s.name}</Typography>

            <Box
              sx={{
                px: 1,
                py: 0.2,
                borderRadius: 1,
                background: s.type === 'topic' ? '#F7942033' : '#20A4F733',
                color: '#fff',
                fontSize: 11,
                textTransform: 'capitalize'
              }}
            >
              {s.type}
            </Box>
          </Box>
        ))}
      </Box>
    </GenericAccordion>
  );
}

function RadioGroup({ value, onChange, options }: RadioGroupProps) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      {options.map((opt) => (
        <Box
          key={opt.value}
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            cursor: 'pointer'
          }}
          onClick={() => onChange(opt.value)}
        >
          <Radio checked={value === opt.value} onChange={() => onChange(opt.value)} />
          <Box
            sx={{
              color: value === opt.value ? '#FDFDFD' : '#B6B6B6',
              fontSize: 14,
              lineHeight: '20px'
            }}
          >
            {opt.label}
          </Box>
        </Box>
      ))}
    </Box>
  );
}

function ProgramModelSelector({ value, onChange }: ProgramModelSelectorProps) {
  return (
    <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
      {/* Título */}
      <Box
        sx={{
          width: '100%',
          py: 2,
          // borderBottom: '1px solid #2A2A2A',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        <Box sx={{ color: '#FDFDFD', fontSize: 14, fontWeight: 700 }}>Program Model</Box>
      </Box>

      {/* Grupo de opções */}
      <Box sx={{ pt: 1, pb: 3 }}>
        <RadioGroup
          value={value}
          onChange={onChange}
          options={[
            { label: 'Masterclass', value: 'masterclass' },
            { label: 'Guided Masterclass', value: 'masterclass&mentorship' },
            { label: 'Mentorship', value: 'mentorship' }
          ]}
        />
      </Box>
    </Box>
  );
}

function InputField({
  label,
  value,
  onChange,
  placeholder,
  ...props
}: {
  label?: string;
  value: string;
  onChange: (v: string) => void;
  placeholder?: string;
}) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '6px', width: '100%' }}>
      {label && (
        <Typography sx={{ color: '#FDFDFD', fontSize: 14, fontWeight: 500, fontFamily: 'Inter, sans-serif' }}>
          {label}
        </Typography>
      )}

      <UiInput
        value={value}
        placeholder={placeholder}
        onChange={(e) => onChange(e.target.value)}
        fullWidth
        {...props}
      />
    </Box>
  );
}

function CtaButton({ children, ...props }: any) {
  return (
    <Button
      {...props}
      disableRipple
      sx={{
        width: '100%',
        padding: '10px 14px',
        borderRadius: '6px',
        background: 'linear-gradient(180deg, #F79420 0%, #F15A26 100%)',
        color: '#FDFDFD',
        fontSize: '13px',
        fontWeight: 600,
        textTransform: 'none',
        fontFamily: 'Inter, sans-serif',

        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',

        '&:hover': {
          background: 'linear-gradient(180deg, #FFA135 0%, #F46A32 100%)'
        },
        '&:active': {
          background: 'linear-gradient(180deg, #D87C1C 0%, #CF4E1C 100%)'
        }
      }}
    >
      {children}
    </Button>
  );
}

function SectionSelect({ section, onChange }: any) {
  return (
    <UiSelect
      value={section}
      onChange={(e) => onChange(e.target.value)}
      size="small"
      sx={{ width: '130px' }}
      MenuProps={{
        PaperProps: { sx: { bgcolor: '#000', color: '#fff' } }
      }}
    >
      <MenuItem value="settings">Settings</MenuItem>
      <MenuItem value="members">Members</MenuItem>
    </UiSelect>
  );
}

function FieldRow({
  label,
  fieldKey,
  data = { mentee: false, mentor: false, admin: false },
  onChange,
  disabled = false
}: {
  label: string;
  fieldKey: string;
  data: { mentee: boolean; mentor: boolean; admin: boolean };
  onChange: (role: 'mentee' | 'mentor' | 'admin', value: boolean) => void;
  disabled?: boolean;
}) {
  const handleChange = (role: 'mentee' | 'mentor' | 'admin', value: boolean) => {
    if (disabled) return;
    onChange(role, value);
  };
  return (
    <SettingsRow>
      <Typography fontSize={12} fontWeight={700} color="#B6B6B6">
        {label}
      </Typography>

      <UiSwitch
        checked={data.mentee}
        disabled={disabled}
        onChange={(e) => handleChange('mentee', e.target.checked)}
      />
      <UiSwitch
        checked={data.mentor}
        disabled={disabled}
        onChange={(e) => handleChange('mentor', e.target.checked)}
      />
      <UiSwitch
        checked={data.admin}
        disabled={disabled}
        onChange={(e) => handleChange('admin', e.target.checked)}
      />
      {/* visible column */}
      <CheckboxBox checked={data.mentee || data.mentor || data.admin} onChange={() => {}} disabled={disabled} />
    </SettingsRow>
  );
}

function RoleColumnsHeader({ mentorLabel, menteeLabel }: { mentorLabel: string; menteeLabel: string }) {
  return (
    <SettingsRow>
      <Typography fontSize={12} fontWeight={700} color="#B6B6B6">
        Required Onboarding Information
      </Typography>
      <Typography fontSize={12} fontWeight={700} color="#B6B6B6" textAlign="center">
        {/* {mentorLabel || 'Mentor'} */}
        Mentor
      </Typography>
      <Typography fontSize={12} fontWeight={700} color="#B6B6B6" textAlign="center">
        {/* {menteeLabel || 'Employee'} */}
        Mentee
      </Typography>
      <Typography fontSize={12} fontWeight={700} color="#B6B6B6" textAlign="center">
        Admin
      </Typography>
      <Typography fontSize={12} fontWeight={700} color="#B6B6B6" textAlign="center">
        Mandatory
      </Typography>
    </SettingsRow>
  );
}

function SettingsLayout({ view = 'configuration' }: { view?: 'configuration' | 'design' }) {
  const groupData = useAppSelector((state) => state.groupDetails);
  const userOptionalFields = groupData?.data?.userOptionalFields;
  const { id: grpId = '', orgId = '' } = useParams();
  const { location } = getUserDetails();

  const [programName, setProgramName] = useState(groupData?.data?.name ?? '');
  const [model, setModel] = useState(groupData?.data?.model ?? 'mentorship');
  const shouldDisableBasicFields = model === 'mentorship' || model === 'masterclass&mentorship';
  const [participantLabel, setParticipantLabel] = useState(groupData?.data?.displayRoles?.mentee ?? '');
  const [advisorLabel, setAdvisorLabel] = useState(groupData?.data?.displayRoles?.mentor ?? '');
  const [maxMatchesPerMentee, setMaxMatchesPerMentee] = useState(
    groupData?.data?.matchesSettings?.maxMatchesPerMentee ?? 1
  );
  const [maxMatchesPerMentor, setMaxMatchesPerMentor] = useState(
    groupData?.data?.matchesSettings?.maxMatchesPerMentor ?? 1
  );
  const [sessionsPerMatch, setSessionsPerMatch] = useState(groupData?.data?.matchesSettings?.sessionsPerMatch ?? 1);
  const [learningObjectives, setLearningObjectives] = useState<{ number: number; objectives: string[] }>({
    number: 1,
    objectives: []
  });
  const [fieldSettings, setFieldSettings] = useState(userOptionalFields ?? {});
  const [isSaving, setIsSaving] = useState(false);
  const { refetch: refetchGroupDetails } = useGroupDetails(grpId, location || '');
  const [isDesignDirty, setIsDesignDirty] = useState(false);
  const manualSaveHandlerRef = useRef<(() => Promise<boolean>) | null>(null);
  const registerManualSaveHandler = useCallback(
    (handler: (() => Promise<boolean>) | null) => {
      manualSaveHandlerRef.current = handler;
    },
    []
  );
  const handleDesignDirtyChange = useCallback((dirty: boolean) => {
    setIsDesignDirty(dirty);
  }, []);

  // SUBJECTS
  const [subjects, setSubjects] = useState<{ name: string; type: 'topic' | 'industry' }[]>([]);
  const [isSubjectModalOpen, setIsSubjectModalOpen] = useState(false);
  const [newSubjectName, setNewSubjectName] = useState('');
  const [newSubjectType, setNewSubjectType] = useState<'topic' | 'industry'>('topic');
  const isMasterclassModel = model === 'masterclass';
  const isMentorsipModel = model === 'mentorship';

  const hasUserEditedRef = useRef(false);
  const markUserEdited = () => {
    hasUserEditedRef.current = true;
  };
  const [lastSavedSnapshot, setLastSavedSnapshot] = useState('');
  const [designTemplate, setDesignTemplate] = useState<any>(null);
  const [designLoading, setDesignLoading] = useState(false);
  const [designError, setDesignError] = useState('');
  const templateId = groupData?.data?.goals?.templateId;
  const templateGoalName = groupData?.data?.goals?.goalName;
  const templateProgramType = groupData?.data?.goals?.programType;
  const [showReviewModal, setShowReviewModal] = useState(false);
  const [showReviewingOverlay, setShowReviewingOverlay] = useState(false);
  const overlayTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    return () => {
      if (overlayTimerRef.current) {
        clearTimeout(overlayTimerRef.current);
      }
    };
  }, []);

  // Hydrate new layout with the same data/logic used in the legacy settings
  useEffect(() => {
    if (!groupData?.data) return;

    // Required fields are always visible for every role
    const requiredAlwaysOn = {
      mentee: true,
      mentor: true,
      admin: true
    };

    const baseFieldSettings: Record<string, { mentee: boolean; mentor: boolean; admin: boolean }> = {
      firstName: requiredAlwaysOn,
      lastName: requiredAlwaysOn,
      email: requiredAlwaysOn,
      category: requiredAlwaysOn,
      timezone: requiredAlwaysOn
    };

    const optionalKeys = [
      'bio',
      'headshot',
      'dob',
      'country',
      'workHistory',
      'educationHistory',
      'hobbiesInterests',
      'socials',
      'companyName',
      'companyInfo',
      'companyPosition'
    ];

    optionalKeys.forEach((key) => {
      const value = userOptionalFields?.[key];
      baseFieldSettings[key] = value ?? {
        mentee: false,
        mentor: false,
        admin: false
      };
    });

    setFieldSettings(baseFieldSettings);
    setModel(groupData.data.model ?? 'mentorship');

    const groupSubjects = groupData.data.subjects || {};
    const hydratedSubjects: { name: string; type: 'topic' | 'industry' }[] = [];
    (groupSubjects.topics || []).forEach((name: string) => hydratedSubjects.push({ name, type: 'topic' }));
    (groupSubjects.industries || []).forEach((name: string) => hydratedSubjects.push({ name, type: 'industry' }));
    setSubjects(hydratedSubjects);
    setProgramName(groupData.data.name ?? '');
    setParticipantLabel(groupData.data.displayRoles?.mentee ?? '');
    setAdvisorLabel(groupData.data.displayRoles?.mentor ?? '');
    setMaxMatchesPerMentee(groupData.data.matchesSettings?.maxMatchesPerMentee ?? 1);
    setMaxMatchesPerMentor(groupData.data.matchesSettings?.maxMatchesPerMentor ?? 1);
    setSessionsPerMatch(groupData.data.matchesSettings?.sessionsPerMatch ?? 1);
    hasUserEditedRef.current = false;
    setLastSavedSnapshot('');
  }, [groupData?.data, userOptionalFields]);

  useEffect(() => {
    const fetchLearningObjectives = async () => {
      if (!grpId || !orgId) return;
      try {
        const res = await API.getLearningObjectives({ grpId, orgId });
        const lo = res?.data?.data?.learningObjectives || {};
        const objectivesArray = lo?.objectives?.map((obj: any) => obj?.objective || obj)?.filter(Boolean) ?? [];
        const safeObjectives = objectivesArray.length ? objectivesArray : [''];
        setLearningObjectives({
          number: lo?.number ?? (safeObjectives.length || 1),
          objectives: safeObjectives
        });
      } catch {
        // ignore fetch errors for now
      }
    };
    fetchLearningObjectives();
  }, [grpId, orgId]);

  const fetchDesignTemplate = useCallback(async () => {
    if (!templateId || !grpId || !orgId) return;
    setDesignLoading(true);
    setDesignError('');
    try {
      const response = await API.getTemplateByTemplateId({
        templateId,
        location,
        grpId,
        orgId
      });
      setDesignTemplate(response?.data?.data || null);
    } catch {
      setDesignTemplate(null);
      setDesignError('Não foi possível carregar o manual builder.');
    } finally {
      setDesignLoading(false);
    }
  }, [grpId, location, orgId, templateId]);

  useEffect(() => {
    if (view === 'design' && templateId) {
      fetchDesignTemplate();
    }
    if (view === 'design' && !templateId) {
      setDesignTemplate(null);
    }
    if (view !== 'design') {
      setDesignError('');
    }
  }, [fetchDesignTemplate, templateId, view]);

  const ManualBuilderInitializer = ({
    template,
    goalName,
    groupId
  }: {
    template: any;
    goalName?: string;
    groupId: string;
  }) => {
    const { dispatch } = useProgramCreation();

    useEffect(() => {
      dispatch({ type: 'SET_PROGRAM_TYPE', payload: 'masterclass' });
      dispatch({ type: 'SET_BUILD_MODE', payload: 'manual' });
      dispatch({ type: 'SET_GROUP_ID', payload: groupId });
      dispatch({ type: 'UPDATE_MASTERCLASS', payload: { title: goalName || '' } });
      dispatch({ type: 'SET_MODULES', payload: mapTemplateToModules(template) });
    }, [dispatch, goalName, groupId, template]);

    return null;
  };

  const normalizedFieldSettings = useMemo(() => {
    const sortedKeys = Object.keys(fieldSettings || {}).sort();
    const normalized: Record<string, { mentee: boolean; mentor: boolean; admin: boolean }> = {};
    sortedKeys.forEach((key) => {
      const value = fieldSettings?.[key] || { mentee: false, mentor: false, admin: false };
      normalized[key] = {
        mentee: !!value.mentee,
        mentor: !!value.mentor,
        admin: !!value.admin
      };
    });
    return normalized;
  }, [fieldSettings]);

  const normalizedSubjects = useMemo(() => subjects.map((s) => ({ name: s.name, type: s.type })), [subjects]);

  const normalizedLearningObjectives = useMemo(
    () => ({
      number: learningObjectives.number,
      objectives: [...(learningObjectives.objectives || [])]
    }),
    [learningObjectives]
  );

  const currentSnapshot = useMemo(
    () =>
      JSON.stringify({
        programName,
        model,
        participantLabel,
        advisorLabel,
        maxMatchesPerMentee,
        maxMatchesPerMentor,
        sessionsPerMatch,
        fieldSettings: normalizedFieldSettings,
        subjects: normalizedSubjects,
        learningObjectives: normalizedLearningObjectives
      }),
    [
      programName,
      model,
      participantLabel,
      advisorLabel,
      maxMatchesPerMentee,
      maxMatchesPerMentor,
      sessionsPerMatch,
      normalizedFieldSettings,
      normalizedSubjects,
      normalizedLearningObjectives
    ]
  );

  useEffect(() => {
    if (!hasUserEditedRef.current && lastSavedSnapshot !== currentSnapshot) {
      setLastSavedSnapshot(currentSnapshot);
    }
  }, [currentSnapshot, lastSavedSnapshot]);

  const settingsDirty = lastSavedSnapshot !== '' && currentSnapshot !== lastSavedSnapshot;
  const hasPendingChanges = settingsDirty || isDesignDirty;

  const updateField = (fieldKey: string, role: 'mentee' | 'mentor' | 'admin', value: boolean) => {
    markUserEdited();
    setFieldSettings((prev: { [x: string]: any }) => ({
      ...prev,
      [fieldKey]: {
        ...prev[fieldKey],
        [role]: value
      }
    }));
  };

  const executeSave = useCallback(async () => {
    if (!hasPendingChanges) return;
    if (!grpId) {
      toast.error('Missing group id');
      return;
    }

    setIsSaving(true);
    try {
      if (view === 'design' && isDesignDirty && manualSaveHandlerRef.current) {
        const manualSaved = await manualSaveHandlerRef.current();
        if (!manualSaved) {
          return;
        }
        setIsDesignDirty(false);
      }

      const optionalPayload: Record<string, any> = {};
      Object.entries(fieldSettings || {}).forEach(([key, value]) => {
        if (OPTIONAL_FIELD_KEYS.includes(key)) {
          optionalPayload[key] = value;
        }
      });

      const topicsList = Array.from(
        new Set(
          subjects
            .filter((s) => s.type === 'topic')
            .map((s) => s.name)
            .filter(Boolean)
        )
      );
      const industriesList = Array.from(
        new Set(
          subjects
            .filter((s) => s.type === 'industry')
            .map((s) => s.name)
            .filter(Boolean)
        )
      );

      const requests: Promise<any>[] = [];

      if (orgId) {
        const formData = new FormData();
        formData.append('name', programName || '');
        formData.append('model', model || groupData?.data?.model || '');
        formData.append('includeTask', `${groupData?.data?.includeTask ?? false}`);
        formData.append('allowEditing', `${groupData?.data?.allowEditing ?? false}`);
        formData.append('mentee', participantLabel || '');
        formData.append('mentor', advisorLabel || '');
        const endDate = groupData?.data?.endDate
          ? new Date(groupData.data.endDate * 1000).toISOString().slice(0, 10)
          : '';
        if (endDate) formData.append('endDate', endDate);
        if (groupData?.data?.logo) formData.append('logo', groupData.data.logo as any);

        requests.push(API.updateGroupInfo({ orgId, grpId, formData }));
      }

      if (Object.keys(optionalPayload).length > 0) {
        requests.push(API.updateOptionalFields({ grpId, data: optionalPayload }));
      }

      if (orgId) {
        requests.push(API.updateTopicsAndIndustry({ grpId, orgId, data: { topics: topicsList }, key: 'topics' }));
        requests.push(
          API.updateTopicsAndIndustry({ grpId, orgId, data: { industries: industriesList }, key: 'industries' })
        );
      }

      if (orgId && model !== 'masterclass') {
        requests.push(
          API.updateAllMatches({
            grpId,
            orgId,
            data: {
              maxMatchesPerMentee,
              maxMatchesPerMentor,
              sessionsPerMatch,
              matchRequest: groupData?.data?.matchesSettings?.matchRequest
            }
          })
        );

        requests.push(
          API.updateLearningObjectives({
            grpId,
            orgId,
            data: {
              number: learningObjectives.number || learningObjectives.objectives.length || 1,
              objectives: learningObjectives.objectives
            }
          })
        );
      }

      await Promise.all(requests);
      await refetchGroupDetails();
      let publishFailed = false;
      if (grpId && location && orgId && model !== 'mentorship') {
        try {
          await API.publishTask({ location, grpId, orgId });
        } catch (err) {
          publishFailed = true;
          console.error('Publish failed after saving settings', err);
        }
      }
      toast.success(publishFailed ? 'Settings updated (publish failed)' : 'Settings updated');
      hasUserEditedRef.current = false;
      setLastSavedSnapshot(currentSnapshot);
    } catch (error) {
      toast.error('Failed to save settings');
    } finally {
      setIsSaving(false);
    }
  }, [
    hasPendingChanges,
    grpId,
    orgId,
    view,
    isDesignDirty,
    programName,
    model,
    participantLabel,
    advisorLabel,
    fieldSettings,
    subjects,
    maxMatchesPerMentee,
    maxMatchesPerMentor,
    sessionsPerMatch,
    learningObjectives,
    groupData,
    currentSnapshot,
    refetchGroupDetails,
    setIsSaving,
    setIsDesignDirty,
    setLastSavedSnapshot
  ]);

  const handleSaveClick = () => {
    if (!hasPendingChanges) return;
    if (view === 'design') {
      setShowReviewModal(true);
      return;
    }
    executeSave();
  };

  const handleContinueReviewing = () => setShowReviewModal(false);

  const handleCreateAndSave = () => {
    setShowReviewModal(false);
    if (overlayTimerRef.current) {
      clearTimeout(overlayTimerRef.current);
    }
    setShowReviewingOverlay(true);
    overlayTimerRef.current = setTimeout(() => {
      setShowReviewingOverlay(false);
      executeSave();
    }, 5000);
  };

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        bgcolor: '#000',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#1c1c1c'
      }}
    >
      <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', overflowY: 'auto', minHeight: 0 }}>
        {/* Linha 2 */}
        <Box
          sx={{
            width: '100%',
            py: '15px',
            px: 2,
            borderBottom: '1px solid #2A2A2A',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            backgroundColor: '#1c1c1c'
          }}
        >
          <Box
            sx={{
              width: 275,
              maxWidth: 250,
              display: 'flex',
              flexDirection: 'column'
            }}
          >
            <InputField
              label="Program Name"
              placeholder="Program Name"
              value={programName}
              onChange={(value) => {
                markUserEdited();
                setProgramName(value);
              }}
            />
          </Box>

            <Box
              sx={{
                display: 'flex',
                maxWidth: 150,
                justifyContent: 'flex-end',
                alignItems: 'center',
                width: 636
              }}
            >
              <CtaButton onClick={handleSaveClick} disabled={!hasPendingChanges || isSaving || showReviewingOverlay}>
                {isSaving ? 'Saving...' : 'Save Changes'}
              </CtaButton>
            </Box>
        </Box>

        {/* Linha 3 em Grid 12 colunas */}
        {view === 'design' ? (
          <Grid container spacing={0} sx={{ flex: 1, minHeight: 0, px: 2, overflow: 'hidden' }}>
            <Grid
              item
              xs={12}
              sx={{
                background: '#1C1C1C',
                display: 'flex',
                flexDirection: 'column',
                minHeight: 0,
                height: '100%'
              }}
            >
              <Box
                sx={{
                  flex: 1,
                  height: '100%',
                  px: 3,
                  py: 2,
                  pr: 1,
                  minHeight: 0,
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 2,
                  overflow: 'hidden'
                }}
              >
                {designError && (
                  <Typography fontSize={12} color="#F16063">
                    {designError}
                  </Typography>
                )}

                {!templateId ? (
                  <Typography fontSize={13} color="#B6B6B6">
                    Nenhum template vinculado a este programa. Crie ou publique um template para visualizar o manual
                    builder.
                  </Typography>
                ) : (
                  <ProgramCreationProvider>
                    <ManualBuilderInitializer template={designTemplate} goalName={templateGoalName} groupId={grpId} />
                    <ManualProgramBuilder
                      hideSaveButton
                      registerSaveHandler={registerManualSaveHandler}
                      onDirtyChange={handleDesignDirtyChange}
                      skipTopicIndustryUpdate
                      onProgramNameChange={(value) => {
                        markUserEdited();
                        setProgramName(value);
                      }}
                      useUpdateGroupTasks
                      updateTemplateId={templateId}
                    />
                  </ProgramCreationProvider>
                )}
              </Box>
            </Grid>
          </Grid>
        ) : (
          <Grid container spacing={0} sx={{ flex: 1, minHeight: 0, px: 2, overflow: 'hidden' }}>
            <Grid
              item
              xs={12}
              md={3}
              sx={{
                borderRight: '1px solid #2A2A2A',
                background: '#1C1C1C',
                display: 'flex',
                flexDirection: 'column',
                minHeight: 0
              }}
            >
              <Box sx={{ flex: 1, px: 2, overflowY: 'auto', minHeight: 0 }}>
                <ProgramModelSelector
                  value={model}
                  onChange={(value) => {
                    markUserEdited();
                    setModel(value);
                  }}
                />
                <Box>
                  <Box sx={{ color: '#FDFDFD', fontSize: 14, fontWeight: 700, mb: 2, mt: 1 }}>User Roles</Box>
                  <Box
                    sx={{
                      mb: 2
                    }}
                  >
                    <InputField
                      label="Label your Program Participant"
                      placeholder="Program Participant"
                      value={participantLabel}
                      onChange={(value) => {
                        markUserEdited();
                        setParticipantLabel(value);
                      }}
                    />
                  </Box>
                  <InputField
                    label="Label your Program Advisor"
                    placeholder="Program Advisor"
                    value={advisorLabel}
                    onChange={(value) => {
                      markUserEdited();
                      setAdvisorLabel(value);
                    }}
                  />
                </Box>
              </Box>
            </Grid>

            <Grid
              item
              xs={12}
              md={isMasterclassModel ? 9 : 6}
              sx={{
                background: '#1C1C1C',
                borderRight: isMasterclassModel ? '1px solid #2A2A2A' : 'none',
                display: 'flex',
                flexDirection: 'column',
                minHeight: 0,
                height: '100%'
              }}
            >
              <Box sx={{ flex: 1, px: 3, py: 1, overflowY: 'auto', pr: 1, minHeight: 0 }}>
                <Box sx={{ pb: 1, borderBottom: '1px solid #2A2A2A', mb: 2 }}>
                  <RoleColumnsHeader mentorLabel={advisorLabel} menteeLabel={participantLabel} />
                </Box>
                  <BasicPanel
                    fieldSettings={fieldSettings}
                    updateField={updateField}
                    disabled={shouldDisableBasicFields}
                  />
                <DemographicPanel fieldSettings={fieldSettings} updateField={updateField} />
                <PersonalPanel fieldSettings={fieldSettings} updateField={updateField} />
                <CompanyPanel fieldSettings={fieldSettings} updateField={updateField} />
                <SubjectsPanel subjects={subjects} openModal={() => setIsSubjectModalOpen(true)} />
              </Box>
            </Grid>

            {isMentorsipModel && (
              <Grid
                item
                xs={12}
                md={3}
                sx={{
                  background: '#1C1C1C',
                  borderLeft: '1px solid #2A2A2A',
                  display: 'flex',
                  flexDirection: 'column',
                  minHeight: 0,
                  height: '100%'
                }}
              >
                <Box sx={{ flex: 1, px: 3, py: 2, overflowY: 'auto', pr: 1, minHeight: 0 }}>
                  <Box sx={{ color: '#FDFDFD', fontSize: 14, fontWeight: 700, mb: 2 }}>Learning Objectives</Box>
                  <Typography sx={{ color: '#B6B6B6', fontSize: 12, mb: 2, lineHeight: '18px' }}>
                    These entries will be displayed to mentees as Learning Objectives and mentors as Areas of Expertise
                    to help matchmaking, so please use neutral language.
                  </Typography>
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                    {learningObjectives.objectives.map((obj, idx) => (
                      <InputField
                        key={idx}
                        label={`Objective ${idx + 1}`}
                        value={obj}
                        placeholder={`Objective ${idx + 1}`}
                        onChange={(v) => {
                          markUserEdited();
                          setLearningObjectives((prev) => {
                            const next = [...prev.objectives];
                            next[idx] = v;
                            return { ...prev, objectives: next, number: next.length || 1 };
                          });
                        }}
                      />
                    ))}
                    <Button
                      variant="outlined"
                      onClick={() => {
                        markUserEdited();
                        setLearningObjectives((prev) => ({
                          number: (prev.objectives.length || 0) + 1,
                          objectives: [...prev.objectives, '']
                        }));
                      }}
                      sx={{
                        color: '#FDFDFD',
                        borderColor: '#565656',
                        textTransform: 'none',
                        fontSize: 12,
                        alignSelf: 'flex-start'
                      }}
                    >
                      + Add Objective
                    </Button>
                  </Box>

                  <Box sx={{ color: '#FDFDFD', fontSize: 14, fontWeight: 700, mb: 2, mt: 3 }}>Mentorship</Box>
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                    <InputField
                      label="Required Learning Objectives for Mentees *"
                      value={`${learningObjectives.number || 0}`}
                      onChange={(v) => {
                        markUserEdited();
                        const number = Number(v) || 0;
                        setLearningObjectives((prev) => ({ ...prev, number }));
                      }}
                    />
                    <InputField
                      label="Maximum matches per participant *"
                      value={`${maxMatchesPerMentee}`}
                      onChange={(v) => {
                        markUserEdited();
                        setMaxMatchesPerMentee(Number(v) || 0);
                      }}
                    />
                    <InputField
                      label="Maximum matches per mentor *"
                      value={`${maxMatchesPerMentor}`}
                      onChange={(v) => {
                        markUserEdited();
                        setMaxMatchesPerMentor(Number(v) || 0);
                      }}
                    />
                    <InputField
                      label="Required sessions per match *"
                      value={`${sessionsPerMatch}`}
                      onChange={(v) => {
                        markUserEdited();
                        setSessionsPerMatch(Number(v) || 0);
                      }}
                    />
                  </Box>
                </Box>
              </Grid>
            )}
          </Grid>
        )}
      </Box>
      <Dialog
        open={isSubjectModalOpen}
        onClose={() => setIsSubjectModalOpen(false)}
        PaperProps={{
          sx: {
            background: '#1C1C1C',
            width: 380,
            p: 3,
            borderRadius: 2,
            border: '1px solid #2A2A2A'
          }
        }}
      >
        <DialogTitle sx={{ color: '#FDFDFD', fontSize: 16, fontWeight: 700 }}>Add New Subject</DialogTitle>

        <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <InputField
            label="Subject Name"
            placeholder="Enter subject name"
            value={newSubjectName}
            onChange={setNewSubjectName}
          />

          <Select
            value={newSubjectType}
            onChange={(e) => setNewSubjectType(e.target.value as any)}
            fullWidth
            size="small"
            sx={{
              background: 'rgba(0,0,0,0.7)',
              outline: '1px solid #868686',
              color: '#fff',
              borderRadius: '6px',
              '& .MuiSelect-icon': { color: '#fff' }
            }}
            MenuProps={{
              PaperProps: { sx: { bgcolor: '#000', color: '#fff' } }
            }}
          >
            <MenuItem value="topic">Topic</MenuItem>
            <MenuItem value="industry">Industry</MenuItem>
          </Select>
        </DialogContent>

        <DialogActions sx={{ p: 2 }}>
          <CtaButton
            onClick={() => {
              markUserEdited();
              setSubjects((prev) => [...prev, { name: newSubjectName, type: newSubjectType }]);
              setNewSubjectName('');
              setNewSubjectType('topic');
              setIsSubjectModalOpen(false);
            }}
            disabled={!newSubjectName.trim()}
          >
            Add Subject
          </CtaButton>
        </DialogActions>
      </Dialog>
      <Dialog
        open={showReviewModal}
        onClose={handleContinueReviewing}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            width: 550,
            bgcolor: '#050505',
            border: '1px solid #2A2A2A',
            borderRadius: 2,
            overflow: 'hidden'
          }
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            px: 6,
            py: 5,
            borderBottom: '1px solid #2A2A2A'
          }}
        >
          <Typography sx={{ color: '#FDFDFD', fontSize: 18, fontWeight: 700 }}>Update Program</Typography>
          <IconButton size="small" onClick={handleContinueReviewing} sx={{ color: '#868686' }}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
        <Box sx={{ px: 6, py: 5, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 5 }}>
          <Typography sx={{ color: '#B6B6B6', fontSize: 14, textAlign: 'center' }}>
            Make sure you've reviewed all lessons and are happy with the content. Once published, this program will be live and visible to assigned audiences.
          </Typography>
          <Box sx={{ display: 'flex', gap: 3.5, width: '100%' }}>
            <Button
              fullWidth
              onClick={handleContinueReviewing}
              sx={{
                background: '#2A2A2A',
                borderRadius: 1,
                color: '#B6B6B6',
                fontSize: 12,
                fontWeight: 500,
                textTransform: 'none'
              }}
            >
              Continue Reviewing
            </Button>
            <Button
              fullWidth
              startIcon={<StarsIcon sx={{ fontSize: 12 }} />}
              onClick={handleCreateAndSave}
              sx={{
                background: 'linear-gradient(180deg, #F68E1F 0%, #DF4A1E 100%)',
                borderRadius: 1,
                color: '#fff',
                fontSize: 12,
                fontWeight: 700,
                textTransform: 'none'
              }}
            >
              Update
            </Button>
          </Box>
        </Box>
      </Dialog>
      {showReviewingOverlay && (
        <Box
          sx={{
            position: 'fixed',
            inset: 0,
            zIndex: 2000,
            background: 'rgba(0,0,0,0.95)',
            display: 'flex',
            alignItems: 'stretch',
            justifyContent: 'stretch'
          }}
        >
          <Box
            sx={{
              flex: 1,
              px: 2,
              py: 4,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <Box sx={{ width: 600, textAlign: 'center', display: 'flex', flexDirection: 'column', gap: 2 }}>
              <Typography sx={{ color: '#FDFDFD', fontSize: 32, fontWeight: 500 }}>Your changes have been saved.</Typography>
              <Typography sx={{ color: '#B6B6B6', fontSize: 16, fontWeight: 600 }}>See you in a few seconds!</Typography>
            </Box>
          </Box>
        </Box>
      )}
    </Box>
  );
}

const ProgramSettings = () => {
  const [activeTopTab, setActiveTopTab] = useState<'configuration' | 'resources' | 'design'>('configuration');
  const [section, setSection] = useState<'settings' | 'members'>('settings');
  const [memberView, setMemberView] = useState<'members' | 'matches'>('members');
  const groupData = useAppSelector((state) => state.groupDetails.data);
  const isDesignDisabled = groupData?.model === 'mentorship';
  const settingsView = activeTopTab === 'design' ? 'design' : 'configuration';
  const matchesDisabled = groupData?.model === 'masterclass';
  const memberViewOptions = useMemo(
    () => [
      { value: 'members', label: 'Members List', disabled: false },
      { value: 'matches', label: 'Matches', disabled: matchesDisabled }
    ],
    [matchesDisabled]
  );

  useEffect(() => {
    if (matchesDisabled && memberView === 'matches') {
      setMemberView('members');
    }
  }, [matchesDisabled, memberView]);

  useEffect(() => {
    if (isDesignDisabled && activeTopTab === 'design') {
      setActiveTopTab('configuration');
    }
  }, [activeTopTab, isDesignDisabled]);

  useEffect(() => {
    if (groupData?.model !== 'masterclass') {
      setSection('members');
    }
  }, [groupData?.model]);

  const renderTopTab = (tab: 'design' | 'configuration' | 'resources', label: string, disabled?: boolean) => {
    const isSelected = activeTopTab === tab;
    return (
      <Box
        role="button"
        onClick={() => !disabled && setActiveTopTab(tab)}
        sx={{
          px: 2.5,
          py: 1,
          cursor: disabled ? 'not-allowed' : 'pointer',
          bgcolor: isSelected ? '#444444' : disabled ? '#151515' : '#2A2A2A',
          opacity: disabled ? 0.5 : 1,
          color: isSelected ? '#FDFDFD' : disabled ? '#868686' : '#B6B6B6',
          fontSize: 12,
          fontWeight: isSelected ? 700 : 400
        }}
      >
        {label}
      </Box>
    );
  };

  return (
    <>
      <Box sx={{ width: '100%', height: '100%', bgcolor: '#0F0F0F', display: 'flex', flexDirection: 'column' }}>
        <Box sx={{ flex: 1, p: 3, overflow: 'hidden', display: 'flex', flexDirection: 'column', gap: 3, minHeight: 0 }}>
          <Box
            sx={{
              flex: 1,
              bgcolor: '#1C1C1C',
              border: '1px solid #2A2A2A',
              borderRadius: 2,
              overflow: 'hidden',
              display: 'flex',
              flexDirection: 'column',
              minHeight: 0
            }}
          >
            {/* Card header with pill and tabs */}
            <Box
              sx={{
                px: 3,
                py: 2,
                borderBottom: '1px solid #2A2A2A',
                display: 'flex',
                alignItems: 'center',
                gap: 2
              }}
            >
              <SectionSelect section={section} onChange={setSection} />

              {section === 'members' ? (
                <Box sx={{ ml: 'auto' }}>
                    <Box sx={{ ml: 'auto', display: 'inline-flex', alignItems: 'center', gap: 2.5 }}>
                      <Typography
                        sx={{ color: '#B6B6B6', fontSize: 12, fontWeight: 700, fontFamily: 'Inter, sans-serif' }}
                      >
                        View:
                      </Typography>
                      <Box
                        data-3="false"
                        data-4="false"
                        data-5="false"
                        data-6="false"
                        data-7="false"
                        data-8="false"
                        data-size="Default"
                        sx={{
                          display: 'inline-flex',
                          borderRadius: 1,
                          overflow: 'hidden',
                          border: '1px solid #2A2A2A'
                        }}
                      >
                        {memberViewOptions.map((option, idx) => {
                          const selected = memberView === option.value;
                          const disabled = option.disabled ?? false;
                          return (
                            <Box
                              key={option.value}
                              role="button"
                              data-size="Default"
                              data-state={selected ? 'selected' : 'default'}
                              sx={{
                                px: 1,
                                py: 0.5,
                                background: selected ? '#444444' : '#2A2A2A',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: 2.5,
                                cursor: disabled ? 'not-allowed' : 'pointer',
                                color: selected ? '#FFFFFF' : '#B6B6B6',
                                fontSize: 12,
                                fontWeight: selected ? 700 : 400,
                                fontFamily: 'Inter, sans-serif',
                                opacity: disabled ? 0.5 : 1,
                                '&:not(:last-of-type)': {
                                  borderRight: '1px solid #2A2A2A'
                                }
                              }}
                              onClick={() => {
                                if (disabled) return;
                                setMemberView(option.value as 'members' | 'matches');
                              }}
                            >
                              <Typography
                                sx={{
                                  fontSize: 12,
                                  fontWeight: selected ? 700 : 400,
                                  color: selected ? '#FFFFFF' : '#B6B6B6'
                                }}
                              >
                                {option.label}
                              </Typography>
                            </Box>
                          );
                        })}
                      </Box>
                    </Box>
                </Box>
              ) : (
                <Box sx={{ ml: 'auto', display: 'inline-flex', borderRadius: 1, overflow: 'hidden' }}>
                  {renderTopTab('design', 'Program Design', isDesignDisabled)}
                  {renderTopTab('configuration', 'Configuration')}
                  {renderTopTab('resources', 'Resources')}
                </Box>
              )}
            </Box>

            {/* Body */}
            <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden', minHeight: 0 }}>
              {section === 'members' ? (
                <Box sx={{ flex: 1, minHeight: 0, overflow: 'hidden' }}>
                  {memberView === 'members' ? <ProgramUsers /> : <MatchesMainPage />}
                </Box>
              ) : (
                <Box sx={{ flex: 1, minHeight: 0, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
                  {activeTopTab === 'resources' ? (
                    <Box sx={{ flex: 1, minHeight: 0, overflow: 'auto' }}>
                      <ContentSettings />
                    </Box>
                  ) : (
                    <Box sx={{ flex: 1, minHeight: 0, overflow: 'auto' }}>
                      <SettingsLayout view={settingsView} />
                    </Box>
                  )}
                </Box>
              )}
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default ProgramSettings;
